import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "csv", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "API", -1)
const _hoisted_3 = { style: {"font-size":"0.75rem"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "ID: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Sub Domain: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Type: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.props.scope.row.source === 'csv')
        ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "info",
            size: "small",
            title: "Order has been imported via csv"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "",
            size: "small",
            title: "Order has been created via API"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
    ]),
    _createVNode(_component_el_popover, {
      placement: "top",
      title: "Proxy",
      width: "auto",
      trigger: "hover"
    }, {
      reference: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.props.scope.row.proxyDomain?.replace(/^https?:\/\//i, '')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_row, { class: "font-bold" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.props.scope.row.proxyDomain), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-3" }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.proxyId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-3" }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.proxyDomain), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-3" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.props.scope.row.proxyType), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}